import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["hiddenAttachments", "showAllBtn", "showRecentBtn"]

  showAll() {
    this.hiddenAttachmentsTargets.forEach(element => {
      element.classList.remove("d-none")
    })
    this.showAllBtnTarget.classList.add("d-none")
    this.showRecentBtnTarget.classList.remove("d-none")
  }

  showRecent() {
    this.hiddenAttachmentsTargets.forEach(element => {
      element.classList.add("d-none")
    })
    this.showAllBtnTarget.classList.remove("d-none")
    this.showRecentBtnTarget.classList.add("d-none")
  }
}